<div class="not-authorized-container">
    <img src="../../../../../assets/images/grpLogo.svg" alt="Logo" class="logo">
    <h1 class="title">{{ 'Access Denied' | translate }}</h1>
    <p class="message">{{ 'You do not have permission to view this page' | translate }}</p>
    <span class="material-icons icon">lock</span>
    <button class="back-button" (click)="goBack()">
        <span class="material-icons">chevron_left</span>
        {{ 'Go Back' | translate }}
    </button>
</div>